import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import ProTimelineLayout from '../layouts/pro_timeline_layout'

class ProTimelinePage extends React.PureComponent {

  render() {
    const { children, title, noRightSidebar } = this.props

    return (
      <ProTimelineLayout noRightSidebar={noRightSidebar} title={title}>
        <PageTitle path={title} />
        {children}
      </ProTimelineLayout>
    )
  }

}

ProTimelinePage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  noRightSidebar: PropTypes.bool,
}

export default ProTimelinePage